import { lazy } from 'react';

import type { TRoute } from 'shared/presentation/modules/definitions';

const DocumentLogin = lazy(
  () => import('modules/authentication/presentation/pages/DocumentLogin'),
);
const Login = lazy(
  () => import('modules/authentication/presentation/pages/Login'),
);
const PasswordRecovery = lazy(
  () => import('modules/authentication/presentation/pages/PasswordRecovery'),
);
const PasswordChannels = lazy(
  () => import('modules/authentication/presentation/pages/PasswordChannels'),
);
const PasswordOTP = lazy(
  () => import('modules/authentication/presentation/pages/PasswordOTP'),
);
const SignUp = lazy(
  () => import('modules/authentication/presentation/pages/SignUp'),
);
const UpdatePassword = lazy(
  () => import('modules/authentication/presentation/pages/UpdatePassword'),
);

const routes: TRoute[] = [
  {
    type: 'route',
    path: '/autenticacao-documento',
    authentication: 'public_only',
    component: DocumentLogin,
  },
  {
    type: 'route',
    path: '/recuperacao-de-senha',
    authentication: 'public_only',
    component: PasswordRecovery,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/canais',
    authentication: 'public_only',
    component: PasswordChannels,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/enviar-codigo',
    authentication: 'public_only',
    component: PasswordOTP,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/registrar',
    authentication: 'public_only',
    component: SignUp,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/login',
    authentication: 'public_only',
    component: Login,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/atualizar-senha/:hash',
    authentication: 'public_only',
    component: UpdatePassword,
  },
  {
    type: 'route',
    path: '/atualizar-senha',
    authentication: 'public_only',
    component: UpdatePassword,
  },
];

export default routes;
